import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { trackCallClick, trackMessengerClick } from "../utils/analytics";
import { colors } from "../theme/designTokens";
import { PRIMARY_PHONE, MESSENGER_URL } from "../constants/stores";
import { ctaMentesUtvonal } from "../constants/ctaMentesOldalak";

// Bolt-független lebegő widget → központi fő szám (constants/stores.js).
const PHONE = `tel:${PRIMARY_PHONE}`;

export default function FloatingContactWidget() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  // A mérőoldalakon nem takarunk rá a tesztfelületre – ld. ctaMentesOldalak.js
  if (ctaMentesUtvonal(pathname)) return null;

  return (
    <div
      className="hidden sm:flex fixed sm:bottom-5 right-5 z-[9999] flex-col items-end"
      style={{ fontFamily: "system-ui" }}
      data-testid="floating-contact-widget"
    >
      <style>{`
        @keyframes pulse {
          0%   { box-shadow: 0 0 0 0 rgba(0,132,255,0.7); }
          70%  { box-shadow: 0 0 0 12px rgba(0,132,255,0); }
          100% { box-shadow: 0 0 0 0 rgba(0,132,255,0); }
        }
        @media (prefers-reduced-motion: reduce) {
          [data-testid="widget-toggle-btn"] { animation: none !important; }
        }
      `}</style>

      {/* Messenger */}
      <a
        href={MESSENGER_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackMessengerClick('lebego_widget')}
        data-testid="widget-messenger-btn"
        style={{
          display: open ? "flex" : "none",
          alignItems: "center",
          gap: "8px",
          marginBottom: "10px",
          padding: "10px 16px",
          borderRadius: "999px",
          color: "#fff",
          textDecoration: "none",
          background: colors.messenger.DEFAULT,
          boxShadow: "0 4px 12px rgba(0,0,0,.22)",
          fontSize: "14px",
          fontWeight: 600,
          whiteSpace: "nowrap",
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
          <path d="M12 2C6.477 2 2 6.145 2 11.243c0 2.908 1.438 5.504 3.686 7.21V22l3.371-1.854C10.024 20.38 11.001 20.5 12 20.5c5.523 0 10-4.145 10-9.257S17.523 2 12 2zm1.007 12.457l-2.55-2.718-4.976 2.718 5.476-5.818 2.613 2.718 4.914-2.718-5.477 5.818z"/>
        </svg>
        Messenger
      </a>

      {/* Hívás */}
      <a
        href={PHONE}
        onClick={() => trackCallClick('lebego_widget')}
        data-testid="widget-phone-btn"
        style={{
          display: open ? "flex" : "none",
          alignItems: "center",
          gap: "8px",
          marginBottom: "10px",
          padding: "10px 16px",
          borderRadius: "999px",
          color: "#fff",
          textDecoration: "none",
          background: colors.brandHover,
          boxShadow: "0 4px 12px rgba(0,0,0,.22)",
          fontSize: "14px",
          fontWeight: 600,
          whiteSpace: "nowrap",
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
          <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
        </svg>
        Hívás
      </a>

      {/* Fő gomb – pulzáló Messenger CTA */}
      {/* Az accessible name a LÁTHATÓ szövegből jön (nincs statikus
          aria-label, ami nyitva „Bezár” helyett mást mondana – WCAG 2.5.3);
          az aria-expanded jelzi, hogy a gomb két linket nyit/zár. */}
      <button
        onClick={() => setOpen(!open)}
        data-testid="widget-toggle-btn"
        aria-expanded={open}
        style={{
          background: colors.messenger.DEFAULT,
          color: "#fff",
          borderRadius: "999px",
          padding: "13px 20px",
          fontWeight: 700,
          fontSize: "15px",
          cursor: "pointer",
          border: "none",
          boxShadow: "0 6px 18px rgba(0,0,0,.28)",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          animation: open ? "none" : "pulse 2s infinite",
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
          <path d="M12 2C6.477 2 2 6.145 2 11.243c0 2.908 1.438 5.504 3.686 7.21V22l3.371-1.854C10.024 20.38 11.001 20.5 12 20.5c5.523 0 10-4.145 10-9.257S17.523 2 12 2zm1.007 12.457l-2.55-2.718-4.976 2.718 5.476-5.818 2.613 2.718 4.914-2.718-5.477 5.818z"/>
        </svg>
        {open ? "Bezár" : "Írj Messenger üzenetet"}
      </button>
    </div>
  );
}
